export default __webpack_public_path__ + "static/media/enter.56c47e57.mp3";